import type { Button } from '@seddi/scene';
import type { SurfaceMaterialModel } from '@seddi/surface-material';
import {
  type VertexDataDesc,
  type FxMeshWithMaterial,
  SHADING_MODEL_DEFAULT,
} from '@seddi/ui-babylon-core';

/**
 * Converts a button to a mesh with material.
 * @param button - The button.
 * @param model - The preferred shading model.
 */
function adapt(
  button: Button,
  model: SurfaceMaterialModel = SHADING_MODEL_DEFAULT,
): FxMeshWithMaterial {
  const { id, buttonMaterial, geometryData } = button;
  const geometry: VertexDataDesc = {
    indices: geometryData!.indices,
    positions: geometryData!.position!,
    normals: geometryData!.normal,
    uvs: geometryData!.uv_0,
  };
  const res: FxMeshWithMaterial = {
    id,
    geometry,
    material: buttonMaterial,
  };
  return res;
}

/**
 * Converts a button to a mesh with material.
 */
export const ButtonAdapter = {
  adapt,
};
